import React from "react";

export default function RiskCard({ title, body, consequence, dark = false, id }) {
  return (
    <div className={"riskcard" + (dark ? " dark" : "")} id={id} data-testid={`risk-${id || ""}`}>
      <div className="xm">✕</div>
      <div style={{ flex: 1 }}>
        <h3>{title}</h3>
        <p>{body}</p>
        {consequence && <div className="conseq">→ {consequence}</div>}
      </div>
    </div>
  );
}
